var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLoading)?_c('div',{staticClass:"loader"},[_c('span',{staticClass:"animation"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }